import React from 'react';

import { Telemetry } from '@videoblocks/kafka-rest-client';

import './MakerEditorHook.less';

interface Props {
  makerEditorLink?: string;
}

const MakerEditorHook = ({ makerEditorLink }: Props) => {
  if (!makerEditorLink) {
    return null;
  }
  return (
    <div className="makerEditorHook hidden lg:block lg:mb-4 xl:mb-auto">
      <span className="makerEditorHook-newFlag">NEW</span>

      <p className="makerEditorHook-title">
        Edit With <span className="makerEditorHook-brandName">Maker</span>
      </p>

      <p className="makerEditorHook-tagLine">
        Add this item to our simple editor to make a polished video in minutes.
      </p>

      <a
        href={makerEditorLink}
        onClick={() => Telemetry.increment('maker.details.cta.click')}
        className="makerEditorHook-cta"
      >
        Start Editing
      </a>
    </div>
  );
};

export default MakerEditorHook;
